<div class="container">
  <a href="tel:02191006901" class="button" (click)="phone()">
    <div class="center">
      <img class="message-icon" src="assets/setting/phone.svg" />
      <span> 021-91006901 </span>
    </div>
  </a>
  <div class="button" (click)="sendReports()">
    <div class="center">
      <img class="message-icon" src="assets/setting/envelope.svg" />
      <span> ارسال پیام </span>
    </div>
  </div>
</div>
